import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab1 = ({
  Item_Code,
  Item_UOM,
  PackingUnit,
  PriceList,
  Customer,
  Supplier,
  BatchNo,
  Currency,
  Rate,
  ValidFrom,
  ValidUpto,
  LeadTimeindays,
  Note,
  Reference,
}) => {


  return (
     <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                   <SelectSearch
                    list={Item_Code.Item_Code_list}
                    label="Item Code"
                    getOptionLabel={(item) =>
                      item.isNew ? "+ Create Item Code" : item.item_code
                    }
                    getOptionValue={(item) => item.item_code}
                    createNewUrl="/master/item/create-item"
                    createNewLabel="Create Item Code"
                    value={Item_Code.value}
                    onChange={(val) => Item_Code.setValue(val)}

                  />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                    list={Item_UOM.Item_UOM_list}
                    label="UOM"
                    getOptionLabel={(item) =>
                      item.isNew ? "+ Create New UOM" : item.name
                    }
                    getOptionValue={(item) => item.name}
                    createNewUrl="/master/uom/create-uom"
                    createNewLabel="Create New UOM"
                    value={Item_UOM.value}
                    onChange={(val) => Item_UOM.setValue(val)}
                  />
                                </div>
                                <div style={{ flex: 1 }}>
                                   <Input
                    id="PackingUnit"
                    label="Packing Unit"
                    style={{
                      height: "30px",
                      border: PackingUnit.Error ? "1px solid red" : "",
                    }}
                    value={PackingUnit.value}
                    onChange={(e) => PackingUnit.setValue(e.target.value)}
                  />
                  <p
                    style={{
                      fontSize: "9px",
                      color: "#2C2B31",
                      marginLeft: "4px",
                    }}
                  >
                    Quantity that must be bought or sold per UOM
                  </p>
                                </div>
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                    list={[{ name: "Standard Buying" }, { name: "Standard Selling" }]}

                    label="Price List"
                    getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
                    value={PriceList?.value || ""}
                    onChange={(value) => PriceList?.setValue?.(value)}
                  />
                                </div>
                                 {PriceList?.PriceList === "Standard Selling" && (
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                      list={Customer.Customer_list}
                      style={{
                        height: "30px",
                        border: Customer.Error ? "1px solid red" : "",
                      }}
                      label="Customer"
                      getOptionLabel={(item) =>
                        item.isNew ? "+ Create New Customer" : item.name
                      }
                      getOptionValue={(item) => item.name}
                      createNewUrl="/master/customer/create-customer"
                      createNewLabel="Create New Customer"
                      value={Customer.value}
                      onChange={(val) => Customer.setValue(val)}
                    />
                                </div>
                                 )}
                {PriceList?.PriceList === "Standard Buying" && (
                   <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={Supplier.Supplier_list}
                      style={{
                        height: "30px",
                        border: Supplier.Error ? "1px solid red" : "",
                      }}
                      label="Supplier"
                      getOptionLabel={(item) =>
                        item.isNew ? "+ Create New Supplier" : item.name
                      }
                      getOptionValue={(item) => item.name}
                      createNewUrl="/master/supplier/create-supplier"
                      createNewLabel="Create New Supplier"
                      value={Supplier.value}
                      onChange={(val) => Supplier.setValue(val)}
                    />
                  </div>
                )}
                 <div style={{ flex: 1 }}>
                                    <SelectSearch
                    list={BatchNo.BatchNo_list}
                    style={{
                      height: "30px",
                      border: BatchNo.Error ? "1px solid red" : "",
                    }}
                    label="Batch No"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={BatchNo.value}
                    onChange={(val) => BatchNo.setValue(val)}
                  />
                                </div>
                            </div>
                         
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Price List Details</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                
                                <div style={{ flex: 1 }}>
                                  <Input
                    id="Currency"
                    label="Currency"
                    style={{
                      height: "30px",
                      border: Currency.Error ? "1px solid red" : "",
                    }}
                    value={Currency.Currency}
                    onChange={(e) => Currency.setValue(e.target.value)}
                    readOnly
                  />
                                </div>

                                <div style={{ flex: 1 }}>
                                
                                      <Input
                    id="Rate"
                    label="Rate"
                    style={{
                      height: "30px",
                      border: Rate.Error ? "1px solid red" : "",
                    }}
                    value={Rate.value}
                    onChange={(e) => Rate.setValue(e.target.value)}
                  />
                                </div>
                                <div style={{ flex: 1 }}>
                  <Input
                    id="ValidFrom"
                    type="date"
                    label="Valid From"
                    style={{
                      height: "30px",
                      border: ValidFrom.Error ? "1px solid red" : "",
                    }}
                    value={ValidFrom.value}
                    onChange={(e) => ValidFrom.setValue(e.target.value)}
                  />
                </div>
                            </div>
  <div style={{ display: 'flex', gap: '15px' }}>
    
                <div style={{ flex: 1 }}>
                  <Input
                    id="ValidUpto"
                    type="date"
                    label="Valid Upto"
                    style={{
                      height: "30px",
                      border: ValidUpto.Error ? "1px solid red" : "",
                    }}
                    value={ValidUpto.value}
                    onChange={(e) => ValidUpto.setValue(e.target.value)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    id="LeadTimeindays"
                    label="Lead Time in days"
                    style={{
                      height: "30px",
                      border: LeadTimeindays.Error ? "1px solid red" : "",
                    }}
                    value={LeadTimeindays.value}
                    onChange={(e) => LeadTimeindays.setValue(e.target.value)}
                  />

                </div>
               
                <div style={{ flex: 1 }}>
                  <Input
                    id="Reference"
                    label="Reference"
                    style={{
                      height: "30px",
                      border: Reference.Error ? "1px solid red" : "",
                    }}
                    value={Reference.value}
                    onChange={(e) => Reference.setValue(e.target.value)}
                  />

                </div>


              </div>

<div style={{ display: 'flex', gap: '15px' }}>
 <div style={{ flex: 1 }}>
                  <Input
                    id="Note"
                    label="Note"
                    style={{
                      height: "30px",
                      border: Note.Error ? "1px solid red" : "",
                    }}
                    value={Note.value}
                    onChange={(e) => Note.setValue(e.target.value)}
                  />
                </div>
</div>

                        </div>
                    </div>
                </div>
            </div>
   
        </div>
  );
};

export default Tab1;
